import React, { Component } from "react";
import Scrollspy from "react-scrollspy";
import profileImage from "../assets/img/profile-img.jpg";

class HeaderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHideSidenav: 'abc',
      toggleIcon: 'bi-list'
    };
  }
  toggleSidenav() {
    let css = (this.state.showHideSidenav === "abc") ? "mobile-nav-active" : "abc";
    (this.state.showHideSidenav === "abc") ? document.body.classList.add('mobile-nav-active') : document.body.classList.remove('mobile-nav-active');
    let icon = (this.state.toggleIcon === "bi-list") ? "bi-x" : "bi-list";
    this.setState({ showHideSidenav: css });
    this.setState({ toggleIcon: icon });
    console.log('status', this.state.showHideSidenav)
  };
  openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  };
  render() {
    return (
      <>
        <i className={`bi ${this.state.toggleIcon} mobile-nav-toggle d-xl-none`} onClick={this.toggleSidenav.bind(this)}></i>
        <header id="header" className={this.state.showHideSidenav}>
          <div className="d-flex flex-column">
            <div className="profile">
              <img
                src={profileImage}
                alt=""
                className="img-fluid rounded-circle"
              />
              <h1 className="text-light">
                <a href="#h">Akshay Nahar</a>
              </h1>
              <div className="social-links mt-3 text-center">
                <a href="#twitter" onClick={() => this.openInNewTab('https://twitter.com/naharakshay8')} className="twitter">
                  <i className="bx bxl-twitter"></i>
                </a>
                <a href="#facebbok" onClick={ () =>this.openInNewTab('https://www.facebook.com/akshay.nahar.90')} className="facebook">
                  <i className="bx bxl-facebook"></i>
                </a>
                <a href="#instagram" onClick={() =>this.openInNewTab('https://www.instagram.com/koshaliya_nandan/')} className="instagram">
                  <i className="bx bxl-instagram"></i>
                </a>
                <a href="tel:+919001535885" className="google-plus">
                  <i className="bx bxl-skype"></i>
                </a>
                <a href="#linkedIN" onClick={() =>this.openInNewTab('https://www.linkedin.com/in/akshay-nahar-%F0%9F%87%AE%F0%9F%87%B3-8775b3163/')} className="linkedin">
                  <i className="bx bxl-linkedin"></i>
                </a>
              </div>
            </div>

            <nav id="navbar" className="nav-menu navbar">
              <ul>
                <Scrollspy
                  items={[
                    "hero",
                    "about",
                    "resume",
                    "contact",
                  ]}
                  currentClassName="active"
                >
                  <li onClick={this.toggleSidenav.bind(this)}>
                    <a href="#hero" className="nav-link scrollto">
                      <i className="bx bx-home"></i> <span>Home</span>
                    </a>
                  </li>
                  <li onClick={this.toggleSidenav.bind(this)}>
                    <a href="#about" className="nav-link scrollto">
                      <i className="bx bx-user"></i> <span>About</span>
                    </a>
                  </li>
                  <li onClick={this.toggleSidenav.bind(this)}>
                    <a href="#resume" className="nav-link scrollto">
                      <i className="bx bx-file-blank"></i> <span>Resume</span>
                    </a>
                  </li>
                  {/* <li>
                    <a href="#portfolio" className="nav-link scrollto">
                      <i className="bx bx-book-content"></i>{" "}
                      <span>Portfolio</span>
                    </a>
                  </li>
                  <li>
                    <a href="#services" className="nav-link scrollto">
                      <i className="bx bx-server"></i> <span>Services</span>
                    </a>
                  </li> */}
                  <li onClick={this.toggleSidenav.bind(this)}>
                    <a href="#contact" className="nav-link scrollto">
                      <i className="bx bx-envelope"></i> <span>Contact</span>
                    </a>
                  </li>
                </Scrollspy>
              </ul>
            </nav>
          </div>
        </header>
      </>
    );
  }
}
export default HeaderComponent;
